import { ImagePublicFileId } from 'src/component/image/image-public-file-id'

export const SuggestedImage = ({ fileId }: { fileId: string }): React.ReactElement => {
  return (
    <div>
      <ImagePublicFileId fileId={fileId} className="w-full h-full object-cover aspect-[6/5]" />
    </div>
  )
}
